import {Tooltip} from 'react-tooltip';

import 'react-tooltip/dist/react-tooltip.css';
import styles from './styles.module.scss';

const TooltipText = (props) => <Tooltip className={styles['tooltip-text']} {...props} />;

export default TooltipText;
